import { RichTextBlock } from "@client/components/RichText";
import { useIsClient } from "@client/utils";
import React from "react";

import { type ThreeDeeEmbed as Props } from "@reactivated";

import styles from "./index.module.scss";

const Canvas = React.lazy(() => import("./Canvas"));

class CanvasErrorBoundary extends React.Component<
    React.PropsWithChildren,
    { hasError: boolean }
> {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        console.warn("ThreejsEmbed Canvas error:", error);
    }

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}

export default function ThreeDeeEmbed({
    model,
    top_text,
    bottom_text,
    ...rest
}: Props) {
    const isClient = useIsClient();

    return (
        <div className={styles.root}>
            {isClient && model && (
                <CanvasErrorBoundary>
                    <React.Suspense fallback={null}>
                        <Canvas
                            className={styles.canvas}
                            model={model.url}
                            {...rest}
                        />
                    </React.Suspense>
                </CanvasErrorBoundary>
            )}
            <div className={styles.contentWrapper}>
                {top_text && (
                    <RichTextBlock
                        className={styles.topText}
                        value={top_text}
                    />
                )}
                {bottom_text && (
                    <RichTextBlock
                        className={styles.bottomText}
                        value={bottom_text}
                    />
                )}
            </div>
        </div>
    );
}
